import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { Link as LinkScroll } from 'react-scroll';
import Select from 'react-select';

//import { Accordion, AccordionItem, AccordionItemHeading, AccordionItemButton, AccordionItemPanel } from 'react-accessible-accordion';
import 'react-accessible-accordion/dist/fancy-example.css';

import { Redirect } from 'react-router-dom';
import { getTokenInfo } from '../../../UseToken';

import { object_type, api_crud_base, api_list_route,  api_crud_route, data_interface, endpoints } from './Config';
import AssecCKEditor from "../../ASSEC_CKEditor/ASSEC_CKEditor";

import 'react-phone-number-input/style.css'

import uniqid from 'uniqid';

import { confirmAlert } from 'react-confirm-alert';

import Main from '../../Main/Init'

//import FileUpload from '../FileUpload/FileUpload' ;

import {

	reqGET,
	reqPOST,
	reqDELETE,
	reqPUT,
	//reqFILE,
	check_interface,
	set_language,
	content_language,
} from '../../../Utils';

import { language } from './Language';
//import { el } from 'date-fns/locale';


export default function Regist(props) {

	const [, set_dados] = useState(null);
	const dados = useRef(null);
	const modulo = useRef(null);
	//const [reviewers, set_reviewers] = useState([]);

	const [isloading, setLoading] = useState(true);
	const [isRedirect, setRedirect] = useState(false);

	const [/*show_vat_form */, set_show_vat_form] = useState('');
	const [show_delete_button, set_show_delete_button] = useState('d-none');

	const [is_edit, set_is_edit] = useState(false)
	//console.log(is_edit)

	const [lang, set_lang] = useState('pt');
    const [, set_lang_id] = useState('1');

	const [read_only, set_read_only] = useState(false)

	//const [nome_convidado, set_nome_convidado] = useState('')
	//const [area_convidado, set_area_convidado] = useState('')
	//const [instituicao_convidado, set_instituicao_convidado] = useState('')
	//const [descricao_convidado, set_descricao_convidado] = useState('')

	//const [topicos, set_topicos] = useState([])
	//const [nome_topico, set_nome_topico] = useState('')

	//const [nome_cfp, set_nome_cfp] = useState('')
	//const [descricao_cfp, set_descricao_cfp] = useState('')
	//const [data_inicio_cfp, set_data_inicio_cfp] = useState('')
	//const [data_submissao_cfp, set_data_submissao_cfp] = useState('')
	//const [data_limite_fim_cfp, set_data_limite_fim_cfp] = useState('')
	//const [data_material_suplementar_cfp, set_data_material_suplementar_cfp] = useState('')
	//const [data_resposta_revisao_cfp, set_data_resposta_revisao_cfp] = useState('')
	//const [data_limite_edicao_cfp, set_data_limite_edicao_cfp] = useState('')	
	//const [data_decisao_final_revisor_cfp, set_data_decisao_final_revisor_cfp] = useState('')
	//const [data_final_processo_cfp, set_data_final_processo_cfp] = useState('')

	//const [topico_selected, set_selected_topico] = useState({label: '', value: ''})
	//const [editor_selected, set_selected_editor] = useState({label: '', value: ''})

	const [/*avaliable_file*/, set_avaliable_file] = useState([])
	const [/*avaliable_lang*/, set_avaliable_lang] = useState([])

	//const [pergunta, set_pergunta] = useState('')

	//const [file_name, set_file_name] = useState([]);

	//const [refresh, setRefresh] = useState(0);

	//const articles = useRef([]);

    //const reviewers = useRef([]);

	const custom_select_styles = {
		container: base => ({
			...base,
			width: '100%',
		}),
		control: base => ({
			...base,
			borderRadius: "10px",
			padding: "2px 10px",
			fontSize: '14px'
		}),
	}

	const evaluation_types = [
		{ value: "teste_escrito", label: "Teste escrito" },
		{ value: "avaliacao_oral", label: "Avaliação oral" }
	];

	const change_evaluation_type = (e, order, moduleid, langid, langcode) => {
		const { /*name,*/ value } = e;

		set_dados(dados.current.content[order]['modules'][moduleid]['evaluation'] = value)

		// console.log('«««««««««««««««««««««««')
		// console.log('Dados Current:' + JSON.stringify(dados.current.content[order]['modules'][moduleid]))
	}

	let compareDataWithInterface = (data, d_interface) => { 

		data.id = check_interface(data.id, d_interface.id)
		data.info = check_interface(data.info, d_interface.info)
		data.info.companycode = check_interface(data.info.companycode, d_interface.info.companycode)
		data.info.name = check_interface(data.info.name , d_interface.info.name)
		data.info.type = check_interface(data.info.tipo , d_interface.info.type)
		data.content[0].modules = check_interface(data.content[0].modules , d_interface.content[0].modules)
	}

	const clean_data = () => {
		// DEEP COPY OF data_interface 
		set_dados(dados.current = JSON.parse(JSON.stringify(data_interface)))
		set_dados(dados.current.info.companycode = getTokenInfo().companycode)
		set_dados(dados.current.info.office = getTokenInfo().office)
		//console.log(dados.current)
	}

	useEffect(() => {

		if(localStorage.getItem('lang') === undefined  || localStorage.getItem('lang') === null || localStorage.getItem('lang') === '') {
            set_lang('pt')
            set_language('pt')
            set_lang_id('1')
        }
        else {
            set_lang(localStorage.getItem('lang'))
            content_language.forEach(el => {
                if(el.code === localStorage.getItem('lang')) {
                    set_lang_id(el.id)
                }
            })
        }

		if(getTokenInfo().profile === 'trainer_user' || getTokenInfo().profile === 'trainee_user') {
			set_read_only(true)
		}

		set_avaliable_file(['pdf', 'doc']);
		set_avaliable_lang(['Português', 'Inglês', 'Espanhol', 'Francês']);

		clean_data();

		try {
			let test = props.location.state.operation;

			if (test === 'edit') {
				set_is_edit(true)
				//if (props.location.state !== undefined) {
				//console.log('->>>>>>>>>>>>>>>>:' + props.location.state.operation)
				//if (props.location.state.operation === 'edit') {
				set_show_vat_form('d-none')
				set_show_delete_button('')
				//console.log('AQUI DENTRO DO STATE')
				//fetch_id_info(props.location.state.item['id']).then(async() => {

				const fetch_id_info = async (id_serch) => {
					let list_route = api_list_route(getTokenInfo().companycode)
					return await reqGET(`${list_route}/${id_serch}`)
						.then(res => {
							compareDataWithInterface(res.data[0], dados.current)

							if(res.data[0].content[0]['modules'] !== undefined) {
								res.data[0].content[0].modules.forEach(el => {
									if(el.id === props.location.state.item['id_module'])
										set_dados(modulo.current = el)
								})
							}



							set_dados(dados.current = res.data[0]);
						})
						.catch(error => error)
				}

				fetch_id_info(props.location.state.item['id_formation']).then(async() => {

					//let lista_revs = await get_reviewers()
					//console.log('lista_revs->', lista_revs)
					//reviewers.current = lista_revs

					//let lista_arts = await get_articles(props.location.state.item['id'])
					//console.log('lista_arts->', lista_arts)
					//articles.current = lista_arts
					//setRefresh(refresh + 1)

					//console.log('++++++++++', articles.current)

					setLoading(false)
				})
			}
		} catch {
			// VAI REGISTAR
			set_show_vat_form('');

			clean_data()

			setLoading(false);

			setRedirect(false);
			return

		}
		// BACK
		//props.history.push(endpoints.list)
		return () => {
			clean_data()
		}

	}, [props])

	const handleSubmit = async e => {
		e.preventDefault();

		if (is_edit === true) {
			//alert('Atualizar PUT')

			confirmAlert({
				title: language[ lang ].edit,
				message: language[ lang ].edit_text ,
				buttons: [
					{
						label: language[ lang ].edit_confirm,
						onClick: () => {

							reqPUT(api_crud_route, dados.current)
								.then(() => { props.history.push(endpoints.list) })
								.catch(() => alert('Problema ao atualizar Registo!'))
						}
					},
					{
						label: language[ lang ].edit_cancel,
						onClick: () => { return }
					}
				]
			})
		} else {
			confirmAlert({
				title: language[ lang ].insert_title ,
				message: language[ lang ].insert_text ,
				buttons: [
					{
						label: language[ lang ].insert_confirm,
						onClick: () => {

							reqPOST(api_crud_route, dados.current)
								.then(() => { props.history.push(endpoints.list) })
								.catch(() => alert('Problema ao inserir Registo!'))
						}
					},
					{
						label: language[ lang ].insert_cancel,
						onClick: () => { return }
					}
				]
			})
		}
	}

	function apagar() {
		confirmAlert({
			title: language[lang].delete_cfp,
			message: language[lang].delete_cfp_text,
			buttons: [
				{
					label: language[lang].delete_confirm,
					onClick: () => {
						// Verificar se existe informação associada ao Cliente
						reqGET(`${api_crud_base}/credits/credits/special/credits/${getTokenInfo().companycode}/${object_type}/${dados.current.id}`).then(
							res => {

								if (res.data.length > 0) {
									confirmAlert({
										title: 'Aviso',
										message: 'A Módulos tem registos associados. Apenas pode ser editada.',
										buttons: [
											{
												label: 'Voltar',
												onClick: () => { return }
											}
										]
									})
								} else {
									//alert('Eliminou')

									reqDELETE(api_crud_route + '/', { id: dados.current.id })
										.then(res => {
											/* alert(res.status === 200 ?
												'Registo Apagado com Sucesso' : 'Problema ao Apagar Registo'); 
 											*/
											props.history.push(endpoints.list)
										})
										.catch(error => alert(error))

								}
							}
						)
					}
				},
				{
					label:  language[lang].delete_cancel,
					onClick: () => { return }
				}
			]
		});
	};

	const handle_change_info_modules = (e) => {
		const { name, value, dataset } = e.target;
		const { order, moduleid } = dataset;

		set_dados(dados.current.content[order]['modules'][moduleid][name] = value)

		//setRefresh(refresh + 1)

		// console.log('«««««««««««««««««««««««')
		// console.log('Dados Current:' + JSON.stringify(dados))
	}

	const handle_change_edit_content_session_lang = (e) => {
		const { name, value, dataset } = e.target;
		const { order, moduleid, lang, langid } = dataset

		if(dados.current.content[0].modules[moduleid]['sessions'] === undefined)
			dados.current.content[0].modules[moduleid]['sessions'] = []

		if(langid === '1') {
			if(dados.current.content[0].modules[moduleid]['sessions'][order]  === undefined || dados.current.content[0].modules[moduleid]['sessions'][order]  === null) {
				dados.current.content[0].modules[moduleid]['sessions'][order] = {name: '', description: ''}
			}
			set_dados(dados.current.content[0].modules[moduleid]['sessions'][order][name] = value)
		}
		else {
			if(dados.current.content[0].modules[moduleid]['sessions'][order]['language'] === undefined)
				dados.current.content[0].modules[moduleid]['sessions'][order]['language'] = []

			if(dados.current.content[0].modules[moduleid]['sessions'][order].language.length  === 0) {
				dados.current.content[0].modules[moduleid]['sessions'][order].language[langid] = {id: langid, code: lang, name: '', description: ''}
			}

			set_dados(dados.current.content[0].modules[moduleid]['sessions'][order]['language'][langid][name] = value)
		}

		if(dados.current.content[0].modules[moduleid]['sessions'][order]['uniqid'] === undefined || dados.current.content[0].modules[moduleid]['sessions'][order]['uniqid'] === '') {
			let uid = uniqid()
			dados.current.content[0].modules[moduleid]['sessions'][order]['uniqid'] = uid

			let event_aux = {
				id: '',
				info: {
					id: '',
					uniqid: uid,
					companycode: getTokenInfo().companycode,
					calendarId: '2',
					title: '',
					body: '',
					category: 'time',
					dueDateClass: '',
					start: '',
					end: '',
					isAllDay: false,
					location: '',
					state: '',
					raw: '',
					isReadOnly: true,
					id_formation: props.location.state.item['id_formation']
				}
			}

			if(name === 'name') {
				if(dados.current.content[0].modules[moduleid].name !== '') {
					event_aux.info.title = value
					event_aux.info.body = '<div>' + dados.current.info.name + '</div><div>' + dados.current.content[0].modules[moduleid].name + '</div>'
				}
				else {
					event_aux.info.title = value
				}
			}

			reqPOST(`${api_crud_base}/calendar/event`, event_aux)
				.then(() => { })
				.catch(() => { })
		}
		else {
			let uid = dados.current.content[0].modules[moduleid]['sessions'][order]['uniqid']
			let data = dados.current.content[0].modules[moduleid]['sessions'][order]['data']
			let inicio = dados.current.content[0].modules[moduleid]['sessions'][order]['inicio']
			let fim = dados.current.content[0].modules[moduleid]['sessions'][order]['fim']

			reqGET(`${api_crud_base}/calendar/event/uniqid/${getTokenInfo().companycode}/${uid}`)
				.then(res => {
					let event_aux = res.data[0]

					if(name === 'name') {
						if(dados.current.content[0].modules[moduleid].name !== '') {
							event_aux.info.title = value
							event_aux.info.body = '<div>' + dados.current.info.name + '</div><div>' + dados.current.content[0].modules[moduleid].name + '</div>'
						}
						else {
							event_aux.info.title = value
						}
					}
					else if(name === 'data') {
						if(inicio !== '') {
							event_aux.info.start = value + 'T' + inicio + ':00.000Z'
						}
						if(fim !== '') {
							event_aux.info.end = value + 'T' + fim + ':00.000Z'
						}
					}
					else if(name === 'inicio' && data !== '') {
						event_aux.info.start = data + 'T' + value + ':00.000Z'
					}
					else if(name === 'fim' && data !== '') {
						event_aux.info.end = data + 'T' + value + ':00.000Z'
					}
					event_aux.info['id_formation'] = props.location.state.item['id_formation']

					reqPUT(`${api_crud_base}/calendar/event`, event_aux)
					 	.then(() => { })
					 	.catch(() => { })
				})
				.catch(() => { })
		}
		
		//console.log('Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«')
		//console.log('Dados Current SESSÕES:' + JSON.stringify(dados.current.content[0].modules[moduleid]['sessions']))
	}

	const get_value_session_content_lang = (order, moduleid, langid, name) => {
		if(dados.current.content[0].modules[moduleid]['sessions'] !== undefined && dados.current.content[0].modules[moduleid]['sessions'][order]['language'] !== undefined && dados.current.content[0].modules[moduleid]['sessions'][order]['language'] !== null) {
			if(dados.current.content[0].modules[moduleid]['sessions'][order]['language'][langid] !== undefined && dados.current.content[0].modules[moduleid]['sessions'][order]['language'][langid] !== null) {
				return dados.current.content[0].modules[moduleid]['sessions'][order]['language'][langid][name];
			}
			else {
				return '';
			}
		}
		else {
			return '';
		}
	}

	const handle_change_content_modules_ckeditor = (value, order, module_order, langid, lang, name) => {
	
		console.log('handle_change_info_ckeditor');

		if(langid === '1') {
			set_dados(dados.current.content[order]['modules'][module_order][name] = value)
		}
		else {
			if(dados.current.content[order]['language'] === undefined)
				dados.current.content[order]['language'] = []

			if(dados.current.content[order].language.length  === 0) {
				dados.current.content[order].language[langid] = {id: langid, code: lang, title: '', text: '', modules: [], media: {image: [], doc: []}}
			}

			set_dados(dados.current.content[order]['language'][langid]['modules'][module_order][name] = value)
		}

		// console.log('Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«')
		// console.log('Dados Current:' + JSON.stringify(dados))
	}

	/*const get_value_content_lang = (order, module_order, langid, name) => {
		if(dados.current.content[order]['language'] !== undefined && dados.current.content[order]['language'] !== null) {
			if(dados.current.content[order]['language'][langid] !== undefined && dados.current.content[order]['language'][langid] !== null) {
				return dados.current.content[order]['language'][langid]['modules'][module_order][name];
			}
			else {
				return '';
			}
		}
		else {
			return '';
		}
	}*/

	const handle_change_content_modules_sessions_ckeditor = (value, order, module_order, session_order, langid, lang, name) => {
	
		console.log('handle_change_info_ckeditor');

		if(langid === '1') {
			set_dados(dados.current.content[order]['modules'][module_order]['sessions'][session_order][name] = value)
		}
		else {
			if(dados.current.content[order]['language'] === undefined)
				dados.current.content[order]['language'] = []

			if(dados.current.content[order].language.length  === 0) {
				dados.current.content[order].language[langid] = {id: langid, code: lang, title: '', text: '', modules: [], media: {image: [], doc: []}}
			}

			set_dados(dados.current.content[order]['language'][langid]['modules'][module_order]['sessions'][session_order][name] = value)
		}

		console.log('Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«')
		console.log('Dados Current:' + JSON.stringify(dados))
	}

	/*const get_value_content_sessions_lang = (order, module_order, session_order, langid, name) => {
		if(dados.current.content[order]['language'] !== undefined && dados.current.content[order]['language'] !== null) {
			if(dados.current.content[order]['language'][langid] !== undefined && dados.current.content[order]['language'][langid] !== null) {
				if(dados.current.content[order]['language'][langid]['modules'][module_order]['sessions'][session_order] !== undefined && dados.current.content[order]['language'][langid]['modules'][module_order]['sessions'][session_order] !== null) {
					return dados.current.content[order]['language'][langid]['modules'][module_order]['sessions'][session_order][name];
				}
				else {
					return '';
				}
			}
			else {
				return '';
			}
		}
		else {
			return '';
		}
	}*/

	return isloading ?
		<main>
			<div className={`dash-cards-2 header`}>
				<h2 className="dash-title">LOADING</h2>
				<p>LOADING</p>
				<div className="overlay">
					<div className="overlay__inner">
						<div className="overlay__content"><span className="spinner"></span></div>
					</div>
				</div>
			</div>
		</main>
		:
		isRedirect
			?
			<Redirect to={endpoints.list} replace />
			:
			<main>
				<div className={`dash-cards-2 header`}>
					<h2 className="dash-title">{language[lang].content}</h2>
					<p>
						<Link to={{ pathname: endpoints.list }}  >
							{language[lang].content}
						</Link>
						&nbsp;&#47;&nbsp;
						{language[lang].content_edit}
					</p>
				</div>

				<div className={`dash-cards-2 body`}>
					<div className="card">
						<div className="card-body">
													
							<form id="form" onSubmit={handleSubmit} className="assec-w-100">
								<input type="hidden" name="id" value={dados.current.id} />

								<h2 className="dash-title">{ language[ lang ].events_data }</h2>

								<div className="form-group">
									<span className="flex-2">
										<label>{ language[ lang ].formation }</label>
										<input type="text" value={dados.current.info.name} className="form-control mb-3 mb-lg-0 rounded-0" readOnly />
									</span>
								</div>

								<div className="div-group">
									<div className={dados.current.content[0].modules.length > 0 ? 'assec-mt-15' : 'd-none'}>
										<h2 className="dash-title">{ language[ lang ].module }</h2>
										<div className="mt-3">
											<LinkScroll activeClass="active" to="accordion_sessions" spy={true} smooth={true} offset={-150} duration={500} className="btn btn-secondary" alt={language[lang].sessions_view} title={language[lang].sessions_view}>
												<img className="assec-mr-15 d-none" alt={language[lang].modules} title={language[lang].sessions_view} src={'./img/plus.svg'} />
												<i className="bi bi-eye text-white me-2"></i>
												{language[lang].sessions_view}
											</LinkScroll>
										</div>
										{
										dados.current.content[0].modules.map((elem, index) => {
											if(elem.id !== props.location.state.item['id_module'])
												return ''
											else {
												return(
													<div key={ `${index}` } className="assec-mb-15" >
														<div className='mb-3 p-3'>
															<div className="form-group">
																<span className="flex-1">
																	<label>{ language[lang].name }</label>
																	<input className="form-control mb-3 mb-lg-0 rounded-0" type="text" name="name" data-order='0' data-moduleid={index} data-lang='pt' data-langid='1' value={elem.name} onChange={(e) => handle_change_info_modules(e)} readOnly={read_only} />
																</span>
															</div>
															<div className="form-group">
																<span className="flex-1">
																	<label>{ language[lang].sessions_number }</label>
																	<input className="form-control mb-3 mb-lg-0 rounded-0" type="number" name="sessions_number" data-order='0' data-moduleid={index} data-lang='pt' data-langid='1' value={elem.sessions_number} onChange={(e) => handle_change_info_modules(e)} /*readOnly={read_only}*/ />
																</span>
																<span className="flex-1">
																	<label>{ language[lang].evaluations_number }</label>
																	<input className="form-control mb-3 mb-lg-0 rounded-0" type="number" name="evaluations_number" data-order='0' data-moduleid={index} data-lang='pt' data-langid='1' value={elem.evaluations_number} onChange={(e) => handle_change_info_modules(e)} /*readOnly={read_only}*/ />
																</span>
																<span className="flex-1">
																	<label>{ language[lang].duration }</label>
																	<input className="form-control mb-3 mb-lg-0 rounded-0" type="number" name="duration" data-order='0' data-moduleid={index} data-lang='pt' data-langid='1' value={elem.duration} onChange={(e) => handle_change_info_modules(e)} readOnly={read_only} />
																</span>
															</div>
															<div className="form-group">
																<span className="flex-1">
																	<label>{ language[lang].module_evaluation }</label>
																	<input className="form-control mb-3 mb-lg-0 rounded-0" type="text" name="evaluation" data-order='0' data-moduleid={index} data-lang='pt' data-langid='1' value={elem.evaluation} onChange={(e) => handle_change_info_modules(e)} /*readOnly={read_only}*/ />
																</span>
																<span className="flex-1 d-none">
																	<label>{ language[lang].module_evaluation }</label>
																	<Select
																		className="div-select"
																		options={evaluation_types}
																		name="evaluation"
																		data-order='0' 
																		data-moduleid={index} 
																		data-lang='pt' 
																		data-langid='1'
																		data-x={elem.evaluation}
																		value={elem.evaluation === '' ? null : { label: language[lang]['module_evaluation_' + elem.evaluation], value: elem.evaluation }}
																		placeholder={language[lang].type_placeholder}
																		onChange={(e) => change_evaluation_type(e, '0', index, '1', 'pt')}
																		styles={custom_select_styles}
																		isDisabled={read_only}
																	/>
																</span>

																<span className="flex-2"></span>
															</div>
															<div className="form-group">
																<span className="flex-1">
																	<label>{ language[lang].module_objectives }</label>

																	{
																	<AssecCKEditor
																		name={"abstract-0"}
																		content={/*'1' === '1' ?*/ elem.objectives /*: get_value_content_lang(0, index, 1, 'objectives')*/}
																		func={(e) => handle_change_content_modules_ckeditor(e, 0, index, '1', 'pt', 'objectives')}
																	/>
																	}
																</span>
															</div>

															<div className="form-group">
																<span className="flex-1">
																	<label>{ language[lang].module_description }</label>

																	<AssecCKEditor
																		name={"abstract-0"}
																		content={/*'1' === '1' ?*/ elem.description /*: get_value_content_lang(0, index, 1, 'description')*/}
																		func={(e) => handle_change_content_modules_ckeditor(e, 0, index, '1', 'pt', 'description')}
																	/>
																</span>
															</div>
														</div>

														<div className="accordion mb-3 p-3 border-0" id="accordion_sessions">

															<div className="mb-3 position-relative">
																{/*<label className="col-form-label fs-6 fw-bold d-block">{language[lang].session_notice}&#58;</label>*/}
																<button type='button' className='info'>
																		<i className="bi bi-info-square text-info fs-4"></i>
																		{
																			elem['sessions'] !== undefined /*&& elem['sessions'][k] !== null && elem['sessions'][k] !== undefined*/ ? 

																				<span className="tooltiptext text-start">{language[lang].session_notice_message_2}</span>
																				
																			:
																				<span className="tooltiptext text-start">{language[lang].session_notice_message_1}</span>
																				
																		}
																</button>
															</div>
															{
															Array.from(Array(parseInt(elem.sessions_number)), (_, k) => {
																if(elem['sessions'] !== undefined && elem['sessions'][k] !== null && elem['sessions'][k] !== undefined) {
																	return (
																		<div key={k}>
																			<div className="accordion-item mt-3">
																				<div className="accordion-header" id={"heading-" + k}>

																					<h2 className="mb-0">
																						<button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target={"#collapse-" + k} aria-expanded="false" aria-controls={"collapse-" + k}>
																							<b>{k + 1}</b>
																							&nbsp;&#45;&nbsp;
																							{elem['sessions'][k].name}
																						</button>
																					</h2>

																				</div>

																				<div id={"collapse-" + k} className={"accordion-collapse collapse"} aria-labelledby={"heading-" + k} data-bs-parent="#accordion_sessions">
																					<div className="accordion-body">															
					
																						<div className="row border-top px-3 d-none" >
																							<div className="col-12 mb-2">
																								<ul className="nav nav-tabs fs-6 border-0 float-right">
																									{
																									content_language.length > 1 ?
																										content_language.map((el_lang, k_lang) => {
																											return (
																												<li key={k_lang} className="nav-item">
																													<a className={"btn btn-sm btn-secondary rounded-0 multi-item" + (k_lang === 0 ? " active" : "")} data-bs-toggle="tab" href={"#kt_tab_pane_session_content_" + k + "_language_" + k_lang}>{el_lang.code}</a>
																												</li>
																											)
																										})
																									:
																										''
																									}
																								</ul>
																							</div>
																						</div>
																						<div className="tab-content" id={"tabModuleContentLang_" + k} >
																							{
																							content_language.length > 1 ?
																								content_language.map((el_lang, k_lang) => {
																									return (
																										<div key={k_lang} className={"tab-pane" + (k_lang === 0 ? " show active" : '')} id={"kt_tab_pane_session_content_" + k +  "_language_" + k_lang} role="tabpanel">
																											<div className="row p-3" >
																												<div className="col-6">
																													<label className="col-form-label fw-bold fs-6">{language[lang].module_name}{k_lang > 0 ? '(' + el_lang.code + ')' : ''}</label>
																													<input
																														type="text"
																														name="name"
																														//defaultValue={elem.name}
																														className="form-control mb-3 mb-lg-0 rounded-0"
																														data-order={k}
																														data-moduleid={index}
																														data-langid={el_lang.id}
																														data-lang={el_lang.code}
																														defaultValue={el_lang.id === '1' ? elem['sessions'][k].name : get_value_session_content_lang(k, index, el_lang.id, 'name') }
																														data-index = { k } 
																														onChange={handle_change_edit_content_session_lang}
																														//readOnly={read_only}
																													/>
																												</div>

																												<div className='col-6 text-right d-none'>
																													<Link className={"button button-gest"} to={{ pathname: endpoints.evaluation, state: { item: {id_formation: props.location.state.item['id_formation'], id_module: props.location.state.item['id_module'], id_session: k}, operation: 'edit' } }} replace>
																														<i className="bi bi-gear"></i>
																														<span className="tooltiptext">{language[lang].gest}</span>
																													</Link>
																												</div>
																											</div>

																											<div className="row p-3" >
																												<div className="col-6 col-sm-3">
																													<label className="col-form-label fw-bold fs-6">{language[lang].module_data}{k_lang > 0 ? '(' + el_lang.code + ')' : ''}</label>
																													<input
																														type="date"
																														name="data"
																														//defaultValue={elem.name}
																														className="form-control mb-3 mb-lg-0 rounded-0"
																														data-order={k}
																														data-moduleid={index}
																														data-langid={el_lang.id}
																														data-lang={el_lang.code}
																														defaultValue={el_lang.id === '1' ? elem['sessions'][k].data : get_value_session_content_lang(k, index, el_lang.id, 'data') }
																														data-index = { k } 
																														onChange={handle_change_edit_content_session_lang}
																														//readOnly={read_only}
																													/>
																												</div>
																												<div className="col-3 col-sm-3">
																													<label className="col-form-label fw-bold fs-6">{language[lang].module_inicio}{k_lang > 0 ? '(' + el_lang.code + ')' : ''}</label>
																													<input
																														type="time"
																														name="inicio"
																														//defaultValue={elem.name}
																														className="form-control mb-3 mb-lg-0 rounded-0"
																														data-order={k}
																														data-moduleid={index}
																														data-langid={el_lang.id}
																														data-lang={el_lang.code}
																														defaultValue={el_lang.id === '1' ? elem['sessions'][k].inicio : get_value_session_content_lang(k, index, el_lang.id, 'inicio') }
																														data-index = { k } 
																														onChange={handle_change_edit_content_session_lang}
																														//readOnly={read_only}
																													/>
																												</div>
																												<div className="col-3 col-sm-3">
																													<label className="col-form-label fw-bold fs-6">{language[lang].module_fim}{k_lang > 0 ? '(' + el_lang.code + ')' : ''}</label>
																													<input
																														type="time"
																														name="fim"
																														//defaultValue={elem.name}
																														className="form-control mb-3 mb-lg-0 rounded-0"
																														data-order={k}
																														data-moduleid={index}
																														data-langid={el_lang.id}
																														data-lang={el_lang.code}
																														defaultValue={el_lang.id === '1' ? elem['sessions'][k].fim : get_value_session_content_lang(k, index, el_lang.id, 'fim') }
																														data-index = { k } 
																														onChange={handle_change_edit_content_session_lang}
																														//readOnly={read_only}
																													/>
																												</div>
																											</div>

																											<div className="row p-3" >
																												<div className="form-group">
																													<span className="flex-1">
																														<label>{ language[lang].module_objectives }</label>

																														<AssecCKEditor
																															name={"abstract-0"}
																															content={/*'1' === '1' ?*/ elem['sessions'][k]['objectives'] /*: get_value_content_sessions_lang(0, index, k, 1, 'objectives')*/}
																															func={(e) => handle_change_content_modules_sessions_ckeditor(e, '0', index, k, '1', 'pt', 'objectives')}
																														/>
																													</span>
																												</div>

																												<div className="form-group">
																													<span className="flex-1">
																														<label>{ language[lang].module_description }</label>

																														<AssecCKEditor
																															name={"abstract-0"}
																															content={/*'1' === '1' ?*/ elem['sessions'][k]['description'] /*: get_value_content_sessions_lang(0, index, k, 1, 'description')*/}
																															func={(e) => handle_change_content_modules_sessions_ckeditor(e, '0', index, k, '1', 'pt', 'description')}
																														/>
																													</span>
																												</div>
																											</div>
																										</div>
																									)
																								})
																							: 
																								''
																							}
																						</div>
						
																					</div>
																				</div>
																			</div>
																		</div>
																	)
																}
																else {
																	return (
																		<div key={k}>
																			<div className="accordion-item mt-3">
																				<div className="accordion-header" id={"heading-" + k}>

																					<h2 className="mb-0">
																						<button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target={"#collapse-" + k} aria-expanded="false" aria-controls={"collapse-" + k}>
																							<b>{k + 1}</b>
																							&nbsp;&#45;&nbsp;
																							{language[lang].session} {k + 1} ({language[lang].session_name_provisional})
																						</button>
																					</h2>

																				</div>

																				<div id={"collapse-" + k} className={"accordion-collapse collapse"} aria-labelledby={"heading-" + k} data-bs-parent="#accordion_sessions">
																					<div className="accordion-body">															
					
																						<div className="row border-top p-3 d-none" >
																							<div className="col-12 mb-2">
																								<ul className="nav nav-tabs fs-6 border-0 float-right">
																									{
																									content_language.length > 1 ?
																										content_language.map((el_lang, k_lang) => {
																											return (
																												<li key={k_lang} className="nav-item">
																													<a className={"btn btn-sm btn-secondary rounded-0 multi-item" + (k_lang === 0 ? " active" : "")} data-bs-toggle="tab" href={"#kt_tab_pane_session_content_" + k + "_language_" + k_lang}>{el_lang.code}</a>
																												</li>
																											)
																										})
																									:
																										''
																									}
																								</ul>
																							</div>
																						</div>
																						<div className="tab-content" id={"tabModuleContentLang_" + k} >
																							{
																								content_language.length > 1 ?
																									content_language.map((el_lang, k_lang) => {
																										return (
																											<div key={k_lang} className={"tab-pane" + (k_lang === 0 ? " show active" : '')} id={"kt_tab_pane_session_content_" + k +  "_language_" + k_lang} role="tabpanel">
																												<div className="row p-3" >
																													<div className="col-12">
																														<label className="col-form-label fw-bold fs-6">{language[lang].module_name}{k_lang > 0 ? '(' + el_lang.code + ')' : ''}</label>
																														<input
																															type="text"
																															name="name"
																															//defaultValue={elem.name}
																															className="form-control mb-3 mb-lg-0 rounded-0"
																															data-order={k}
																															data-moduleid={index}
																															data-langid={el_lang.id}
																															data-lang={el_lang.code}
																															defaultValue=''
																															data-index = { k } 
																															onChange={handle_change_edit_content_session_lang}
																														/>
																													</div>
																												</div>

																												<div className="row p-3" >
																													<div className="col-6 col-sm-3">
																														<label className="col-form-label fw-bold fs-6">{language[lang].module_data}{k_lang > 0 ? '(' + el_lang.code + ')' : ''}</label>
																														<input
																															type="date"
																															name="data"
																															//defaultValue={elem.name}
																															className="form-control mb-3 mb-lg-0 rounded-0"
																															data-order={k}
																															data-moduleid={index}
																															data-langid={el_lang.id}
																															data-lang={el_lang.code}
																															defaultValue=''
																															data-index = { k } 
																															onChange={handle_change_edit_content_session_lang}
																														/>
																													</div>
																													<div className="col-3 col-sm-3">
																														<label className="col-form-label fw-bold fs-6">{language[lang].module_inicio}{k_lang > 0 ? '(' + el_lang.code + ')' : ''}</label>
																														<input
																															type="time"
																															name="inicio"
																															//defaultValue={elem.name}
																															className="form-control mb-3 mb-lg-0 rounded-0"
																															data-order={k}
																															data-moduleid={index}
																															data-langid={el_lang.id}
																															data-lang={el_lang.code}
																															defaultValue=''
																															data-index = { k } 
																															onChange={handle_change_edit_content_session_lang}
																														/>
																													</div>
																													<div className="col-3 col-sm-3">
																														<label className="col-form-label fw-bold fs-6">{language[lang].module_fim}{k_lang > 0 ? '(' + el_lang.code + ')' : ''}</label>
																														<input
																															type="time"
																															name="fim"
																															//defaultValue={elem.name}
																															className="form-control mb-3 mb-lg-0 rounded-0"
																															data-order={k}
																															data-moduleid={index}
																															data-langid={el_lang.id}
																															data-lang={el_lang.code}
																															defaultValue=''
																															data-index = { k } 
																															onChange={handle_change_edit_content_session_lang}
																														/>
																													</div>
																												</div>

																												<div className="row p-3" >
																													<div className="form-group">
																														<span className="flex-1">
																															<label>{ language[lang].module_objectives }</label>

																															<AssecCKEditor
																																name={"objectives"}
																																content={''}
																																func={(e) => handle_change_content_modules_sessions_ckeditor(e, '0', index, k, '1', 'pt', 'objectives')}
																															/>
																														</span>
																													</div>

																													<div className="form-group">
																														<span className="flex-1">
																															<label>{ language[lang].module_description }</label>

																															<AssecCKEditor
																																name={"description"}
																																content={''}
																																func={(e) => handle_change_content_modules_sessions_ckeditor(e, '0', index, k, '1', 'pt', 'description')}
																															/>
																														</span>
																													</div>
																												</div>
																											</div>
																										)
																									})
																								: 
																									''
																							}
																						</div>
						
																					</div>
																				</div>
																			</div>
																		</div>
																	)
																}
															})
															}
														</div>
													</div>
												)
											}
										})
										}
									</div>
								</div>
							</form>
						</div>
					</div>
				</div>

				<div className={'dash-cards-2 footer'}>
					<nav className="navbar bottom-navbar navbar-light">
						<div className="navbar-footer">
							<ul className="navbar-nav float-left"></ul>
							<ul className="navbar-nav float-right">
								{ 
									props.location.state.backup_operation !== undefined && props.location.state.backup_operation === 'module_view' ? 
										<li className="nav-item">
											<Link className="nav-link btn-cancel" to={{ pathname: '/formation_content_gest', state: { item: {id: props.location.state.formation_id}, operation: 'edit' } }}  >
												<img alt='' src={'./img/seta_2.svg'} />
												<span>{language[lang].back}</span>
											</Link>
										</li>
									: 
										props.location.state.backup_operation !== undefined && props.location.state.backup_operation === 'session_view' ? (
											<li className="nav-item">
												<Link className="nav-link btn-cancel" to={{ pathname: '/formation_content_regist', state: { item: {id: props.location.state.formation_id}, operation: 'edit' } }}  >
													<img alt='' src={'./img/seta_2.svg'} />
													<span>{language[lang].back}</span>
												</Link>
											</li>
										) :
											props.location.state.go_back_operation !== undefined && props.location.state.go_back_operation === 'main_view' ? (
												<li className="nav-item">
													<Link className="nav-link btn-cancel" to={{ pathname: Main.view.endpoint}}  >
														<img alt='' src={'./img/seta_2.svg'} />
														<span>{language[lang].back}</span>
													</Link>
												</li>
											) :
												<li className="nav-item">
													<Link className="nav-link btn-cancel" to={{ pathname: endpoints.list }} replace>
														<img alt={language[lang].back} src={'./img/seta_2.svg'} />
														<span>{language[lang].back}</span>
													</Link>
												</li>
								}

								<li className={"nav-item " + show_delete_button}>
									<button onClick={apagar} className="nav-link btn-delete">
										<img alt={language[lang].delete} src={'./img/eliminar_b.svg'} />
										<span><span>{language[lang].delete}</span></span>
									</button>
								</li>
								<li className="nav-item">
									<button type="submit" form="form" className="nav-link">
										<img alt={language[lang].save} src={'./img/save.svg'} />
										<span><span>{language[lang].save}</span></span>
									</button>
								</li>
							</ul>
						</div>
					</nav>
				</div>
			</main >
}
